import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from '../model/store/interfaces'

import { getReport } from './report'

const getTutor = (state: ProgressReportStore): ProgressReport['tutor'] | null => getReport(state)?.tutor || null

export const tutor = {
  getTutor: (state: ProgressReportStore): ProgressReport['tutor'] | null => getTutor(state),
  isTutor: (state: ProgressReportStore): boolean => !!getTutor(state),
}
